<template>
  <div class="kindergarten-detail-container">
    <h3>Детали ДО</h3>
    <div v-if="kindergartenDocumentInfo">
      <div class="info-section">
        <h4>Информация о ДО</h4>
        <p><strong>ID:</strong> {{ kindergartenDocumentInfo.id }}</p>
        <p><strong>БИН:</strong> {{ kindergartenDocumentInfo.bin }}</p>
        <p><strong>КБЕ:</strong> {{ kindergartenDocumentInfo.kbe }}</p>
        <p><strong>Тип собственности:</strong> {{ kindergartenDocumentInfo.ownershipType.name }} ({{ kindergartenDocumentInfo.ownershipType.code }})</p>
      </div>

      <button v-if="hasAccess(adminRoles)" class="btn btn-warning" @click="openEditKindergartenModal">Внести изменение в ДО</button>

      <!-- Модальное окно для редактирования -->
      <b-modal v-model="showEditKindergartenModal" title="Редактирование ДО" hide-footer>
        <form @submit.prevent="submitUpdatedForm">
          <div class="mb-3">
            <label for="bin" class="form-label">БИН</label>
            <input type="text" v-model="updatedDocument.bin" class="form-control" id="bin" required />
          </div>
          <div class="mb-3">
            <label for="kbe" class="form-label">КБЕ</label>
            <input type="text" v-model="updatedDocument.kbe" class="form-control" id="kbe" required />
          </div>
          <div class="mb-3">
            <label for="ownershipType" class="form-label">Тип собственности</label>
            <select v-model="updatedDocument.ownershipType" class="form-select" id="ownershipType" required>
              <option v-for="ownership in ownershipTypes" :key="ownership.code" :value="ownership">
                {{ ownership.name }}
              </option>
            </select>
          </div>
          <button type="submit" class="btn btn-primary">Сохранить изменения</button>
        </form>
      </b-modal>

      <div class="lms-systems-section">
        <h4>Системы LMS</h4>
        <!-- Кнопка для добавления ЛМС -->
        <button v-if="hasAccess(adminRoles)" class="btn btn-success" @click="openCreateLmsModal">Добавить ЛМС</button>
        <b-table-simple bordered="">
          <b-thead head-variant="light">
            <b-tr>
              <b-th>ID LMS</b-th>
              <b-th>Название ДО</b-th>
              <b-th>Банк БИН</b-th>
              <b-th>Банк БИК</b-th>
              <b-th>ИИК</b-th>
              <b-th>Группа региона</b-th>
              <b-th>Тип региона</b-th>
              <b-th>Тип населенного пункта</b-th>
              <b-th>Населенный пункт</b-th>
              <b-th>Адрес</b-th>
              <b-th>Номер договора и дата</b-th>
              <b-th>Проектная мощность</b-th>
              <b-th>Сумма надбавки</b-th>
              <b-th>Статус ДО</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(lmsSystem, index) in kindergartenDocumentInfo.lmsSystems" :key="index">
              <b-td>
                {{ lmsSystem.lmsId }}
                <button v-if="hasAccess([...adminRoles, ...accountantRoles])" class="btn btn-sm" @click="openEditLmsModal(lmsSystem)">
                  ✏️
                </button>
              </b-td>
              <b-td>{{ lmsSystem.kindergartenName }}</b-td>
              <b-td>{{ lmsSystem.bankBin }}</b-td>
              <b-td>{{ lmsSystem.bankBic }}</b-td>
              <b-td>{{ lmsSystem.iik }}</b-td>
              <b-td>{{ lmsSystem.regionGroup?.code }}</b-td>
              <b-td>{{ lmsSystem.regionType?.code }}: {{ lmsSystem.regionType?.name }}</b-td>
              <b-td>{{ lmsSystem.localityType?.code }}: {{ lmsSystem.localityType?.name }}</b-td>
              <b-td>{{ lmsSystem.kato?.nameRu }}</b-td>
              <b-td>{{ lmsSystem.address }}</b-td>
              <b-td>{{ lmsSystem.contractNumberAndDate }}</b-td>
              <b-td>{{ lmsSystem.childrenCapacity }}</b-td>
              <b-td>
                <p v-for="(allowance, allowanceIndex) in lmsSystem.kindergartenAllowances" :key="allowanceIndex">
                  ({{allowance.educationalType?.code}}) {{allowance.educationalType?.name}} : {{allowance.allowanceAmount}} тг.
                </p>
                <button v-if="hasAccess(adminRoles)" class="btn btn-sm" @click="openCreateAllowanceModal(lmsSystem)">
                  <b>+</b>
                </button>
              </b-td>
              <b-td>{{ getStatusLabel(lmsSystem.status) }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <!-- Модальное окно для добавления ЛМС -->
      <b-modal v-model="showLmsModal" title="Управление ЛМС" hide-footer>
        <form @submit.prevent="submitCreateLmsForm">
          <div class="mb-3">
            <label for="kindergarten_name" class="form-label">Название ДО</label>
            <input type="text" v-model="currentLmsSystem.kindergartenName" class="form-control" id="kindergarten_name" required />
          </div>
          <div class="mb-3">
            <label for="bankBic" class="form-label">БИК банка</label>
            <input type="text" v-model="currentLmsSystem.bankBic" class="form-control" id="bankBic" required />
          </div>
          <div class="mb-3">
            <label for="bankBin" class="form-label">БИН банка</label>
            <input type="text" v-model="currentLmsSystem.bankBin" class="form-control" id="bankBin" required />
          </div>
          <div class="mb-3">
            <label for="iik" class="form-label">ИИК</label>
            <input type="text" v-model="currentLmsSystem.iik" class="form-control" id="iik" required />
          </div>
          <div class="mb-3">
            <label for="lmsId" class="form-label">ID ЛМС</label>
            <input type="text" v-model="currentLmsSystem.lmsId" class="form-control" id="lmsId" required />
          </div>
          <div class="mb-3">
            <label for="lmsName" class="form-label">НАЗВАНИЕ ЛМС</label>
            <input type="text" v-model="currentLmsSystem.lmsName" class="form-control" id="lmsName"/>
          </div>
          <div class="mb-3">
            <label for="katoGroup" class="form-label">Като</label>
            <multiselect
                v-model="currentLmsSystem.kato"
                :options="katoList"
                :searchable="true"
                :closeOnSelect="true"
                track-by="code"
                :custom-label="formattedKatoLabel"
                placeholder="Выберите Като"
                :multiple="false"
                :clear-on-select="true"
            />
          </div>
          <div class="mb-3">
            <label for="address" class="form-label">Адрес</label>
            <input type="text" v-model="currentLmsSystem.address" class="form-control" id="address" required />
          </div>
          <div class="mb-3">
            <label for="contractNumberAndDate" class="form-label">Номер договора и дата</label>
            <input type="text" v-model="currentLmsSystem.contractNumberAndDate" class="form-control" id="contractNumberAndDate" required />
          </div>
          <div class="mb-3">
            <label for="regionGroup" class="form-label">Группа региона</label>
            <select v-model="currentLmsSystem.regionGroup" class="form-select" id="regionGroup" required>
              <option v-for="regionGroup in regionGroups" :key="regionGroup.code" :value="regionGroup">
                {{ regionGroup.code }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="localityType" class="form-label">Тип населенного пункта</label>
            <select v-model="currentLmsSystem.localityType" class="form-select" id="localityType" required>
              <option v-for="localityType in localityTypes" :key="localityType.code" :value="localityType">
                {{ localityType.name }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="regionType" class="form-label">Тип региона</label>
            <select v-model="currentLmsSystem.regionType" class="form-select" id="regionType" required>
              <option v-for="regionType in regionTypes" :key="regionType.code" :value="regionType">
                {{ regionType.name }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="childrenCapacity" class="form-label">Проектная мощность</label>
            <input type="number" v-model="currentLmsSystem.childrenCapacity" class="form-control" id="childrenCapacity"/>
          </div>
          <div class="mb-3">
            <label for="status" class="form-label">Статус ДО</label>
            <select v-model="currentLmsSystem.status" class="form-select" id="status" required>
              <option value="ACTIVE">Активный</option>
              <option value="INACTIVE">Не активный</option>
            </select>
          </div>
          <button type="submit" class="btn btn-primary">{{ isEditMode ? "Сохранить изменения" : "Создать ЛМС" }}</button>
        </form>
      </b-modal>

      <!-- Модальное окно для создания allowance -->
      <b-modal v-model="showCreateAllowanceModal" title="Добавить Надбавку" hide-footer>
        <form @submit.prevent="submitCreateAllowanceForm">
          <div class="mb-3">
            <label for="educationalType" class="form-label">Тип образования</label>
            <select v-model="newAllowance.educationalType" class="form-select" id="educationalType" required>
              <option v-for="type in educationalTypes" :key="type.code" :value="type">
                {{ type.name }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="durationTime" class="form-label">Время прибывание</label>
            <select v-model="newAllowance.durationTime" class="form-select" id="durationTime" required>
              <option v-for="type in durationTimeList" :key="type.code" :value="type">
                {{ type.name }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="allowanceAmount" class="form-label">Сумма надбавки</label>
            <input
                type="number"
                v-model="newAllowance.allowanceAmount"
                class="form-control"
                id="allowanceAmount"
                step="0.01"
                required
            />
          </div>
          <button type="submit" class="btn btn-primary">Создать</button>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <p>Загрузка информации...</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import Multiselect from "vue-multiselect";
import { useRoute } from 'vue-router';
import {
  getKindergartenDocumentInfoById,
  updateKindergartenDocumentInfo,
  createLmsSystem,
  updateLmsSystem,
  createKindergartenAllowance
} from '@/services/directoryService';
import cacheService from '@/services/cacheService'
import {
  KindergartenDocumentInfo,
  OwnershipType,
  LmsSystemItem,
  RegionGroup,
  LocalityType,
  RegionType,
  Kato, KindergartenAllowanceItem, EducationalType, DurationTimeType
} from '@/types/kindergarten';
import authService from '@/services/authService';

export default defineComponent({
  name: 'KindergartenDetailView',
  components: {
    Multiselect
  },
  setup() {
    const adminRoles: string[] = authService.getAdminRoles();
    const accountantRoles: string[] = authService.getAccountantRoles();
    const hasAccess = authService.hasAccess;
    const route = useRoute();
    const kindergartenDocumentId = route.params.id;
    const kindergartenDocumentInfo = ref<KindergartenDocumentInfo | null>(null);
    const showEditKindergartenModal = ref(false);
    const ownershipTypes = ref<OwnershipType[]>([]);
    const showLmsModal = ref(false); // Модальное окно для добавления ЛМС
    const regionGroups = ref<RegionGroup[]>([]); // Список групп региона
    const localityTypes = ref<LocalityType[]>([]); // Список типов населенных пунктов
    const regionTypes = ref<RegionType[]>([]); // Список типов региона
    const katoList = ref<Kato[]>([]); // Список като
    const durationTimeList = ref<DurationTimeType[]>([]);
    const currentLmsSystem = ref<LmsSystemItem>({
      id: 0,
      lmsId: '',
      lmsName: '',
      kindergartenName: '',
      bankBic: '',
      bankBin: '',
      iik: '',
      regionGroup: null,
      localityType: null,
      regionType: null,
      kato: null,
      address: '',
      contractNumberAndDate: '',
      childrenCapacity: null,
      status: '',
      kindergartenAllowances: [],
      kindergartenDocumentInfo: kindergartenDocumentInfo.value,
    });
    const isEditMode = ref(false);
    const showCreateAllowanceModal = ref(false);
    const newAllowance = ref<KindergartenAllowanceItem>({
      id: 0,
      educationalType: {
        id: 0,
        name: "",
        code: 0
      },
      durationTime: {
        id: 0,
        name: "",
        code: 0
      },
      allowanceAmount: 0,
      lmsSystem: null,
    });
    const educationalTypes = ref<EducationalType[]>([]);

    // Объект для редактирования
    const updatedDocument = ref<KindergartenDocumentInfo>({
      id: null,
      bin: '',
      name: '',
      bankBic: '',
      bankBin: '',
      kbe: '',
      iik: '',
      ownershipType: null,
      lmsSystems: [],
    });

    onMounted(async () => {
      await fetchKindergartenDocumentInfo();
      regionGroups.value = await cacheService.useRegionGroup().fetchRegionGroup();
      katoList.value = await cacheService.useKatoStore().fetchKato();
      localityTypes.value = await cacheService.useLocalityType().fetchLocalityType();
      regionTypes.value = await cacheService.useRegionType().fetchRegionType();
      ownershipTypes.value = await cacheService.useOwnershipType().fetchOwnershipType();
      educationalTypes.value = await cacheService.useEducationalType().fetchEducationalType();
      durationTimeList.value = await cacheService.useDurationTime().fetchDurationTime();
    });

    const openCreateAllowanceModal = (lmsSystem: LmsSystemItem) => {
      newAllowance.value = {
        id: 0,
        educationalType: {
          id: 0,
          name: "",
          code: 0
        },
        durationTime: {
          id: 0,
          name: "",
          code: 0
        },
        allowanceAmount: 0,
        lmsSystem: lmsSystem,
      };
      showCreateAllowanceModal.value = true;
    };

    const submitCreateAllowanceForm = async () => {
      try {
        await createKindergartenAllowance(newAllowance.value);
        showCreateAllowanceModal.value = false;
        await fetchKindergartenDocumentInfo();
        // Обновить данные на странице после успешного создания
        console.log("Надбавка создана успешно");
      } catch (error) {
        console.error("Ошибка при создании надбавки:", error);
      }
    };


    const openEditLmsModal = (lmsSystem : LmsSystemItem) => {
      currentLmsSystem.value = lmsSystem;
      isEditMode.value = true;
      showLmsModal.value = true;
    };

    const openCreateLmsModal = () => {
      currentLmsSystem.value = {
        id: 0,
        lmsId: '',
        lmsName: '',
        kindergartenName: '',
        bankBic: '',
        bankBin: '',
        iik: '',
        regionGroup: null,
        localityType: null,
        regionType: null,
        kato: null,
        address: '',
        contractNumberAndDate: '',
        childrenCapacity: null,
        status: '',
        kindergartenAllowances: [],
        kindergartenDocumentInfo: kindergartenDocumentInfo.value,
      };
      isEditMode.value = false;
      showLmsModal.value = true;
    };

    const fetchKindergartenDocumentInfo = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (token && kindergartenDocumentId) {
          kindergartenDocumentInfo.value = await getKindergartenDocumentInfoById(token, kindergartenDocumentId as string);
          if (kindergartenDocumentInfo.value) {
            updatedDocument.value = { ...kindergartenDocumentInfo.value };
          }
        }
      } catch (error) {
        console.error('Ошибка при получении информации о ДО:', error);
      }
    }

    const submitCreateLmsForm = async () => {
      try {
        const tmpKindergartenDocumentInfo = kindergartenDocumentInfo.value;
        if (tmpKindergartenDocumentInfo) tmpKindergartenDocumentInfo.lmsSystems = [];
        currentLmsSystem.value.kindergartenDocumentInfo = tmpKindergartenDocumentInfo;
        if (isEditMode.value) {
          await updateLmsSystem(currentLmsSystem.value);
        } else {
          await createLmsSystem(currentLmsSystem.value);
        }
        showLmsModal.value = false;
        await fetchKindergartenDocumentInfo();
      } catch (error) {
        console.error('Ошибка при создании ЛМС:', error);
      }
    };

    const openEditKindergartenModal = () => {
      showEditKindergartenModal.value = true; // Открытие модального окна
    };

    const submitUpdatedForm = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (token) {
          await updateKindergartenDocumentInfo(updatedDocument.value); // Отправка обновленных данных
          showEditKindergartenModal.value = false; // Закрытие модального окна
          await fetchKindergartenDocumentInfo(); // Обновление данных на странице
        }
      } catch (error) {
        console.error('Ошибка при обновлении ДО:', error);
      }
    };

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const getStatusLabel = (status: string) => {
      switch (status) {
        case "ACTIVE":
          return "Активный";
        case "INACTIVE":
          return "Не активный";
        default:
          return status || "Неизвестно";
      }
    };

    return {
      accountantRoles,
      kindergartenDocumentInfo,
      showEditKindergartenModal,
      updatedDocument,
      ownershipTypes,
      openEditKindergartenModal,
      submitUpdatedForm,
      showLmsModal,
      currentLmsSystem,
      regionGroups,
      durationTimeList,
      localityTypes,
      regionTypes,
      katoList,
      isEditMode,
      openCreateLmsModal,
      openEditLmsModal,
      submitCreateLmsForm,
      formattedKatoLabel,
      newAllowance,
      educationalTypes,
      showCreateAllowanceModal,
      submitCreateAllowanceForm,
      openCreateAllowanceModal,
      adminRoles,
      hasAccess,
      getStatusLabel
    };
  },
});
</script>

<style scoped>
.kindergarten-detail-container {
  padding: 20px;
}

.info-section,
.lms-systems-section {
  margin-bottom: 20px;
}

h4 {
  margin-top: 20px;
}
</style>
